import React from "react";
import styles from "./EndGameMenus.module.css";
import { useNavigate } from "react-router-dom";

const EndGameMenus = ({ style, playAgain, setShowMenus, score, collectedCount}) => {
  const navigate = useNavigate();
  const backgroundImage = `${process.env.REACT_APP_WEB_URL}/image/endGameBg.png`;
  const tg_info = JSON.parse(localStorage.getItem("tg_info"));
  const tgUserId = tg_info?.tgUserId;
  const gameName = tg_info?.gameName;
  const botName = tg_info?.botName;
  const link =
    process.env.REACT_APP_SWEAT_WEB_URL +
    `/?tg_user_id=${encodeURIComponent(
      tgUserId
    )}&game_name=${gameName}&bot_name=${botName}`;
  return (
    <div
      className={styles.container}
      style={{
        // backgroundImage: `url(${backgroundImage})`,
        ...style,
      }}>

      <div className={styles.thankYouContainer}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around', paddingTop: '20%'}}>
          <div className={styles.score}>
            <img src="/image/coin.png" alt="coin" className={styles.coin}/>
            <span className={styles.scoreText}>{score}</span>
          </div>
          <div className={styles.score}>
            <img src="/image/count.png" alt="count" className={styles.count}/>
            <span className={styles.scoreText}>{collectedCount}</span>
          </div>
        </div>
        <img src="/image/thankyou.png" alt="" className={styles.thankyou} />
      </div>
      <div className={styles.desc}>
        Congrats, you’ve qualified for our 5 USDT weekly Lucky draw! Enter now
        through our mission site.
      </div>
      <div className={styles.btnContainer}>
        <img
          src="/image/enterNowBtn.png"
          alt=""
          className={styles.btn}
          onClick={() => {
            window.open(link, "_blank");
          }}
        />
        <img
          src="/image/playAgainBtn.png"
          alt=""
          className={styles.btn}
          onClick={playAgain}
        />
        <img
          src="/image/backHomeBtn.png"
          alt=""
          className={styles.btn}
          onClick={() => {
            setShowMenus(-10);
            navigate("/");
          }}
        />
      </div>
    </div>
  );
};

export default EndGameMenus;
